module.exports = __webpack_public_path__ + "static/media/departments.f1a5f399.svg";